import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { auth } from '../../services/firebase';
import { useAuth } from '../../hooks/useAuth';
import { ROUTES } from '../../constants/routes';
import logo from '../../resources/ramirez_rentals_transparent.png';

/**
 * NavigationBar component
 * Main navigation bar with responsive layout and authentication-aware buttons
 */
const NavigationBar: React.FC = () => {
  const navigate = useNavigate();
  const { userData } = useAuth();
  const nodeRef = useRef(null);

  const handleClick = () => {
    navigate(ROUTES.HOME);
  };

  const handleLogout = async () => {
    await auth.signOut();
    navigate(ROUTES.LOGIN);
  };

  // Determine if user is logged in based on auth state
  const isLoggedIn = userData.userAddress !== null || userData.isAdmin !== null;
  const isAdmin = userData.isAdmin === true;

  return (
    <nav className='navbar'>
      <img src={logo} className='nav-logo' alt='ramirez-rentals' onClick={handleClick} />

      <TransitionGroup className="nav-buttons-container">
        <CSSTransition
          key={isLoggedIn ? 'logged-in' : 'logged-out'}
          timeout={{
            enter: 650, // 400ms animation + 250ms delay
            exit: 250
          }}
          classNames="nav-transition"
          nodeRef={nodeRef}
        >
          <div className="nav-buttons-group" ref={nodeRef}>
            {isLoggedIn ? (
              <>
                {isAdmin && (
                  <button
                    className='nav-button'
                    onClick={() => navigate(ROUTES.ADMIN)}
                  >
                    Admin
                  </button>
                )}
                <button
                  className='nav-button'
                  onClick={() => navigate(`${ROUTES.DASHBOARD}?board=payment`)}
                >
                  Payment
                </button>
                <button
                  className='nav-button'
                  onClick={() => navigate(`${ROUTES.DASHBOARD}?board=history`)}
                >
                  History
                </button>
                <button
                  className='nav-button'
                  onClick={() => navigate(`${ROUTES.DASHBOARD}?board=lease`)}
                >
                  Lease
                </button>
                <button
                  className='nav-button logout'
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <button
                  className='nav-button'
                  onClick={() => navigate(ROUTES.LOGIN)}
                >
                  Login
                </button>
                <button
                  className='nav-button'
                  onClick={() => navigate(ROUTES.REGISTER)}
                >
                  Create account
                </button>
              </>
            )}
          </div>
        </CSSTransition>
      </TransitionGroup>
    </nav>
  );
};

export default NavigationBar;
